import { CompanyValue, CompanyMembershipSection } from "./entities";
import { EntityValidator, EntityValidationResult } from "../lib/entities/validation";

export const companyValueValidator: EntityValidator<CompanyValue> = companyValue => {
  const result: EntityValidationResult<CompanyValue> = {};
  if (!companyValue.description) {
    result.description = "required";
  } else if (companyValue.description.length > 255) {
    result.description = "too_long";
  }
  return result;
};

export const membershipSectionValidator: EntityValidator<CompanyMembershipSection> = section => {
  const result: EntityValidationResult<CompanyMembershipSection> = {};
  if (!section.name) {
    result.name = "required";
  } else if (section.name.length > 30) {
    result.name = "too_long";
  }
  return result;
};



// WEBPACK FOOTER //
// ./frontend/src/companies/validation.ts